/**
 * Checks whether `localStorage` can be used in the current environment.
 *
 * @returns `true` when `localStorage` is writable, otherwise `false`.
 */
export const isLocalStorageAvailable = (): boolean => {
    try {
        const x = '__storage_test__';
        localStorage.setItem(x, x);
        localStorage.removeItem(x);

        return true;
    } catch (e) {
        return false;
    }
};
